import dynamic from 'next/dynamic'

export const DynamicZipNotCoveredModal = dynamic(
  () => import('.').then((mod) => mod.ZipNotCoveredModal),
  { ssr: false },
)
